import { Grid } from '@mui/material';
import { memo, useEffect } from 'react';

import useTopPanel from 'hooks/useTopPanel';

import ProductStatistics from './items/ProductStatistics';

const StatisticsObject = () => {
  const { setComponent } = useTopPanel();

  useEffect(() => {
    setComponent(
      <div className='component-title flex gap-8 items-center'>
        Top mahsulotlar statistikasi
      </div>
    );
  }, []);

  return (
    <div className='component-wrapper boss-residential-complex-wrapper'>
      <Grid container spacing={2} columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
        <Grid item={true} lg={12} md={12} sm={12} xs={12}>
          <ProductStatistics />
        </Grid>
      </Grid>
    </div>
  );
};
export default memo(StatisticsObject);
